import React, { useEffect, useState } from 'react'
import { Cash ,Bank} from 'react-bootstrap-icons'
import { postGetMicrotransactionApi } from '../../Api/ClientServices'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'
import { separate } from '../../Seprate/Seprate'
import Style from './Microtransaction.module.css'
import { errorToast } from '../../Toast/Toast'
import { convertDate } from '../../Utils/Helper/Helper'

const Microtransaction = () => {
    const[data,setData]=useState([])
    useEffect(()=>{
        getTransaction()
    },[])
    const getTransaction=async()=>{
        postGetMicrotransactionApi((succ,res)=>{
            if(succ){
                if(res.status===0){
                    errorToast("مشکلی پیش آمده است")
                }else{
                    setData(res.transactions)
                }
            }else{
                console.error(res)
            }
        })
    }
    console.log(data)
    return (
        <div className={Style.pageHolder}>
            <BurgerMenuTitle title={"ریز تراکنش"}/>
            {data.length===0? 
            <div className={Style.NotOrderFoundHolder}>
                <div className={Style.ImageBasket}><img src="/Assets/Images/Order/trak.png" alt="برست" /></div>
                <p className={Style.NoOrderText}>تراکنشی برای شما ثبت نشد</p>
            </div>
            :
            data&&data.map((item,index)=>{
                return(
                <div key={index} className={Style.eachTransaction}>
                    <div className={item.amount<0 ?Style.redColor :Style.greenColor}>{item.amount<0? "-" : "+"}</div>
                    <div className={Style.top}>
                        <h3 className={Style.transaction}><Bank className={Style.icons}/>{item.amount<0 ? "برداشت از حساب" : "واریز به حساب"}</h3>
                        <h3 className={Style.price}><Cash className={Style.icons}/> مبلغ <span style={{color:item.amount<0 ?"red" :"green",direction: "ltr"}}>{separate(item.amount)}</span> تومان </h3>
                        {/* <p className={Style.reason}><ChatSquareText className={Style.icons}/>{item.cause} </p> */}
                    </div>
                    <div className={Style.bottom}>
                        <h3 className={Style.date}>{convertDate(item.date)}</h3>
                    </div>
                </div>

                )
            })}
            
        </div>
    )
}

export default Microtransaction